import { defineComponent as _defineComponent } from 'vue'
import { ref,computed, watch, nextTick } from 'vue'  
 import store from '@/store'  
 import { buildCoverageStateId } from '@/models/ui/CoverageUiState'
 import {buildCoverageIterationUiStateId} from '@/models/ui/CoverageIterationUiState'
 import { getCoverageState, getCoverageStateTradKey } from '@/enum/CoverageState'
 import { getCoverageStep, getCoverageStepTradKey } from '@/enum/CoverageStep'   
 import MissionDetailGraphics from '@/components/mission/MissionDetailGraphics.vue' 
 import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
 import { isAloDbMissionGlobalCoverage } from '@/models/alodb/AloDbMissionGlobal'


 
export default /*#__PURE__*/_defineComponent({
  __name: 'CoverageDetailScienceGraphics',
  props: {
    isleft: { type: Boolean },
    uiid: null
  },
  setup(__props: any) {

const props = __props as {
   isleft:boolean,
   uiid:string
 };

 
 

 
 
  
 const missionGlobal = computed(()=> store.myGetters.modifiedAdmMissionGlobal)    
 
 const simulation_uiid = computed(()=> buildSimulationUIStateId(missionGlobal.value.MIG_ID!,"detail")) 
 const coverage_uiid = computed(()=> buildCoverageStateId(missionGlobal.value.MIG_ID!,"detail")) 
 const coverageiteration_uiid = computed(()=> coverageState.value.selectedCoverageId?buildCoverageIterationUiStateId(coverageState.value.selectedCoverageId!,"detail"):null)     
 // const coverageIterationState = computed(()=> coverageiteration_uiid.value?store.myGetters.coverageIterationStateByUiid(coverageiteration_uiid.value):null)

 store.myActions.UI_ENSURE_GRA_STATE({uiid:props.uiid,config:{
      variableX:"datSimu",
      variableY:"duration"
  }})

 const graphUiState = computed(()=> store.myGetters.graphUiStateByUiid(props.uiid))
 const simulationUiState = computed(()=> store.myGetters.simulationUiStateByUiid(simulation_uiid.value))       
 const coverageState = computed(()=> store.myGetters.coverageStateByUiid(coverage_uiid.value))       
 const coverageIteration = computed(()=> coverageState.value.selectedCoverageId?store.myGetters.coverageIterationsById[coverageState.value.selectedCoverageId]:null)   
 const gliderKeys = computed(()=>Object.keys(coverageIteration.value?.resultMipJson || {}).filter(n => n.startsWith('GLIDER')))

 

 const selectedGliderIdx = computed({
   get() {
     return graphUiState.value?.gliderIdx ?? -1
   },
   set(value:number) {
    graphUiState.value!.gliderIdx = value
   }
 })

 const stateTradKey = computed(()=> getCoverageStateTradKey(getCoverageState(coverageIteration.value?.COV_PROCESSING_STATE))) 
 const stepTradKey = computed(()=> getCoverageStepTradKey(getCoverageStep(coverageIteration.value?.COV_PROCESSING_STEP)))

  


return { __sfc: true,props, missionGlobal, simulation_uiid, coverage_uiid, coverageiteration_uiid, graphUiState, simulationUiState, coverageState, coverageIteration, gliderKeys, selectedGliderIdx, stateTradKey, stepTradKey, MissionDetailGraphics, isAloDbMissionGlobalCoverage }
}

})